<template>
    <portal to="popups" v-if="show">
        <transition name="modal">
            <div class="z-50" :class="{'mask fixed inset-0 bg-overlay-500': overlay}">
                <div class="table-center">
                    <div class="container bg-white relative outline-none shadow-lg rounded-md" ref="source" :style="getStyle()"
                         @click.stop="">
                        <div class="absolute right-0 top-0 text-white text-xl p-2 mr-1 cursor-pointer" v-show="showClose"
                             @click="closePopup">X
                        </div>
                        <div class="bg-primary-600 text-white text-xl p-2 pr-8 select-none cursor-move rounded-t-md" tabindex="-1"
                             @mousedown="mousedown">
                            {{ heading }}
                        </div>
                        <div class="overflow-scroll p-2 relative" :style="`max-height: ${maxHeight}`">
                            <slot></slot>
                        </div>
                        <div class="bg-white rounded-b-md" v-if="$slots.footer">
                            <div class="text-right border-t border-gray-500 p-2">
                                <slot name="footer"></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </portal>
</template>

<script>

export default {
    props: {
        heading: String,
        width: {
            type: String,
            default: "auto"
        },
        showClose: {
            type: Boolean,
            default: true
        },
        closeOnEscape: {
            type: Boolean,
            default: true
        },
        show: {
            type: Boolean,
            default: false
        },
        modal: {
            type: Boolean,
            default: false
        },
        overlay: {
            type: Boolean,
            default: true
        },
        maxHeight: {
            type: String,
            default: "80vh"
        }
        
    },
    watch: {
        show() {
            this.pos = {
                x: -1, y: -1
            };
        }
    },
    data() {
        return {
            pos: {
                x: -1,
                y: -1
            },
            move: false
        }
    },
    created() {
        this.diff = {x: 0, y: 0};
        window.addEventListener('keydown', this.keydown);
        window.addEventListener('mousemove', this.mousemove);
        window.addEventListener('mouseup', this.mouseup);
    },
    destroyed() {
        window.removeEventListener('keydown', this.keydown);
        window.removeEventListener('mousemove', this.mousemove);
        window.removeEventListener('mouseup', this.mouseup);
    },
    methods: {
        mouseup() {
            this.move = false;
        },
        mousemove(event) {
            if (event.buttons !== 1 || !this.move)
                return;

            this.pos = {
                x: event.clientX - this.diff.x,
                y: event.clientY - this.diff.y
            };
        },
        mousedown(event) {
            this.move = true;
            const rect = this.$refs.source.getBoundingClientRect();
            this.diff = {
                x: event.clientX - rect.left,
                y: event.clientY - rect.top
            };
        },
        keydown(event) {
            if (this.closeOnEscape && event.keyCode === 27) {
                this.closePopup()
            }
        },
        outsideClick() {
            if (!this.modal) {
                this.closePopup()
            }
        },
        closePopup() {
            this.$emit('close')
            this.$emit('update:show', false)
        },
        getStyle() {
            if (this.pos.x !== -1) {
                return {
                    width: this.width,
                    left: this.pos.x + "px",
                    top: this.pos.y + "px",
                    position: "fixed"
                }
            }
            return {
                width: this.width,
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.mask {
    transition: opacity 0.3s ease;
}

.container {
    transition: all 0.3s ease;
    transition-property: opacity, transform;
}

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .container,
.modal-leave-active .container {
    transform: scale(1.1);
}

</style>
